import { render, staticRenderFns } from "./FaturaAlacakForm.vue?vue&type=template&id=60fd10da"
import script from "./FaturaAlacakForm.vue?vue&type=script&lang=ts"
export * from "./FaturaAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports